import { Box, Typography, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface EducationRecordProps {
  degree: string;
  institution: string;
  focus?: string;
  year?: string;
}

const EducationRoot = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  boxShadow: 'inset 0 0 0 1px rgba(125,211,199,0.06)',

  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const EducationRecord = ({
  degree,
  institution,
  focus,
  year,
  ...props
}: EducationRecordProps & BoxProps) => {
  return (
    <EducationRoot {...props}>
      <Typography variant="subtitle2" sx={{ color: 'primary.main' }}>
        {degree}
      </Typography>

      <Typography
        variant="caption"
        sx={{ letterSpacing: '0.08em', color: 'text.secondary' }}
      >
        {institution}
      </Typography>

      {focus && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Focus: {focus}
        </Typography>
      )}

      {year && (
        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
          Completed: {year}
        </Typography>
      )}
    </EducationRoot>
  );
};
